<script lang="ts">
    import Dropzone from "svelte-file-dropzone";
    import * as Dialog from "$lib/components/ui/dialog";
    import { Button } from "$lib/components/ui/button";
    import { CirclePlus } from 'lucide-svelte';
    import { t  } from 'svelte-i18n'
    import { container } from "tsyringe";
    import { CreateDocument, CreateDocumentToken } from "$src/application/projects/sub/documents/commands/CreateDocument";
    import { useQueryClient } from "@sveltestack/svelte-query";
    import ScrollArea from "$lib/components/ui/scroll-area/scroll-area.svelte";
    import { File } from 'lucide-svelte';

    export let groupStoreId: number
	export let projectId: number
    
    const queryClient = useQueryClient()

    interface FileEvent {
        detail: {
            acceptedFiles: any[];
            fileRejections: any[];
        };
    }

    let files: { accepted: any[]; rejected: any[] } = {
        accepted: [],
        rejected: []
    };

    function handleFilesSelect(e: FileEvent) {
        const { acceptedFiles, fileRejections } = e.detail;
        files.accepted = [...files.accepted, ...acceptedFiles];
        files.rejected = [...files.rejected, ...fileRejections];
    }

    function handleRemoveAll() {
        files.accepted = [];
    }

    async function handleUpload() {
        if (files.accepted.length === 0) return;

        for(let i=0 ; i < files.accepted.length ; i++) {
            let docFile = files.accepted[i];

            try {
                const command = container.resolve<CreateDocument>(CreateDocumentToken);
                command.execute(groupStoreId, projectId, docFile); //no await
            }
            catch(error) {
               
            }
        }

        queryClient.invalidateQueries('documents');
        files.accepted = [];
        files.rejected = [];
        dialogOpen = false;
    }

    let dialogOpen = false;
</script>

<Dialog.Root bind:open={dialogOpen} >
    <Dialog.Trigger>
        <Button size="sm" class="h-7 gap-1">
            <CirclePlus class="h-3.5 w-3.5" />
            <span>
              {$t('page.projects.documents.new')}
            </span>
        </Button>
    </Dialog.Trigger>
    <Dialog.Content class="max-w-md">
      <Dialog.Header>
        <Dialog.Title>{$t('page.projects.documents.new')}</Dialog.Title>
        <Dialog.Description>
            {$t('page.projects.documents.newdescription')}
        </Dialog.Description>
      </Dialog.Header>
        <div>
            <Dropzone 
                name="test"
                containerClasses="max-w-md"
                on:drop={handleFilesSelect} 
                accept={[".pdf", ".jpg", ".png", ".jpeg"]}>
                {$t('page.projects.documents.dropzone')}
            </Dropzone>
        </div>
        {#if files.accepted.length > 0}
            <Button 
                on:click={handleRemoveAll}> 
                {$t('page.projects.documents.new-removeall')}
            </Button>
        {/if}
        <ScrollArea class="h-44">
            <ol>
                {#each files.accepted as item}
                    <li class="flex truncate gap-2">
                        <File class="h-5 w-5"/>
                        {item.name}
                    </li>
                {/each}
            </ol>
        </ScrollArea>
        <Dialog.Footer class="flex flex-row w-full justify-between">
            <Button variant="secondary" class="flex justify-start"  on:click={() => {dialogOpen = false;}}> 
                {$t('global.messages.close')}
            </Button>
            {#if files.accepted.length > 0}
                <Button  class="flex justify-end" on:click={handleUpload}>
                     {$t('page.projects.documents.insert')}
                     - {files.accepted.length}
                </Button>
            {/if}
        </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>